export default value => {
  return typeof value === 'string' || value instanceof String
}
